import SeeMoreDescription from "../components/ui/SeeMoreDescription";
import moment from "moment";
import "moment/locale/ar"; // Arabic support
import "moment/locale/de";
import Linkify from "linkify-react";
import { useLanguage } from "../context/LanguageContext";

// dayjs.extend(relativeTime);
// dayjs.locale("ar");

export const a2e = (value) => value.replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d));
export const description = (value, isSeeMore = false, lastRowElement = "") =>
    value &&
    (isSeeMore ? (
        <SeeMoreDescription value={value} />
    ) : (
        value.split(/(?:\r\n|\r|\n)/g).map((line, i) => (
            <span key={i}>
                {line}
                {i === value.split(/(?:\r\n|\r|\n)/g).length - 1 ? lastRowElement : ""}
                <br />
            </span>
        ))
    ));

export const getUnit = (
    value,
    plural = "",
    sinuglar = "",
    two = "",
    isFeminine = false,
    language = "ar",
    returnOriginalValue = false
) => {
    const parsedValue = parseInt(value);
    const returnValue = returnOriginalValue ? value : parsedValue;
    if (language === "ar") {
        const oneUnit = sinuglar + (isFeminine ? " واحدة" : " واحد");
        if (parsedValue === 0) {
            return { value: 0, label: sinuglar };
        } else if (parsedValue === 1) {
            return { value: "", label: oneUnit };
        } else if (parsedValue === 2) {
            return { value: "", label: two };
        } else if (parsedValue < 11) {
            return { value: returnValue, label: plural };
        } else {
            return { value: returnValue, label: sinuglar };
        }
    } else if (language === "de") {
        // German language rules
        if (parsedValue === 1) {
            return { value: "ein", label: sinuglar };
        } else if (parsedValue === 2) {
            return { value: "zwei", label: plural };
        } else {
            return { value: returnValue, label: plural };
        }
    } else {
        if (parsedValue === 1) {
            return { value: "one", label: sinuglar };
        } else {
            return { value: returnValue, label: plural };
        }
    }
};

export const printGovernment = (governments, government_id) => {
    if (governments.length > 1) {
        let government = governments.find((government) => {
            return government.value == government_id;
        });
        if (!government) {
            return "لم يتم العثور على المحافظة";
        }
        return government.text;
    } else {
        return "يتم تحميل المحافظات";
    }
};

export const printIdOfOptions = (
    options,
    id,
    loadingText = "يتم الآن التحميل",
    notFoundText = "لم يتم العثور على نتيجة"
) => {
    if (options.length > 1) {
        let option = options.find((value) => {
            return value.value == id;
        });
        if (!option) {
            return notFoundText;
        }
        return option.text;
    } else {
        return loadingText;
    }
};

export const printUnit = (
    value,
    plural = "",
    language = "ar",
    sinuglar = "",
    two = "",
    isFeminine = false,
    returnOriginalValue = false
) => {
    if (plural === "دقيقة") {
        if (language === "ar") {
            sinuglar = "دقيقة";
            two = "دقيقتان";
            plural = "دقائق";
            isFeminine = true;
        } else if (language === "de") {
            sinuglar = "Minute";
            two = "Minuten";
            plural = "Minuten";
            isFeminine = false;
        } else {
            sinuglar = "minute";
            two = "minutes";
            plural = "minutes";
            isFeminine = false;
        }
    } else if (plural === "ثانية") {
        if (language === "ar") {
            sinuglar = "ثانية";
            two = "ثانيتان";
            plural = "ثواني";
            isFeminine = true;
        } else if (language === "de") {
            sinuglar = "Sekunde";
            two = "Sekunden";
            plural = "Sekunden";
            isFeminine = false;
        } else {
            sinuglar = "second";
            two = "seconds";
            plural = "seconds";
            isFeminine = false;
        }
    } else if (plural === "مرة") {
        if (language === "ar") {
            sinuglar = "مرة";
            two = "مرتان";
            plural = "مرات";
            isFeminine = true;
        } else if (language === "de") {
            sinuglar = "Mal";
            two = "Mal";
            plural = "Mal";
            isFeminine = false;
        } else {
            sinuglar = "time";
            two = "times";
            plural = "times";
            isFeminine = false;
        }
    } else if (plural === "سؤال") {
        if (language === "ar") {
            sinuglar = "سؤال";
            two = "سؤالان";
            plural = "أسئلة";
            isFeminine = false;
        } else if (language === "de") {
            sinuglar = "Frage";
            two = "Fragen";
            plural = "Fragen";
            isFeminine = false;
        } else {
            sinuglar = "question";
            two = "questions";
            plural = "questions";
            isFeminine = false;
        }
    } else if (plural === "ساعة") {
        if (language === "ar") {
            sinuglar = "ساعة";
            two = "ساعاتان";
            plural = "ساعات";
            isFeminine = true;
        } else if (language === "de") {
            sinuglar = "Stunde";
            two = "Stunden";
            plural = "Stunden";
            isFeminine = true;
        } else {
            sinuglar = "hour";
            two = "hours";
            plural = "hours";
            isFeminine = false;
        }
    } else if (plural === "فيديو") {
        if (language === "ar") {
            sinuglar = "فيديو";
            two = "فيديوهان";
            plural = "فيديوهات";
            isFeminine = false;
        } else if (language === "de") {
            sinuglar = "Video";
            two = "Videos";
            plural = "Videos";
            isFeminine = false;
        } else {
            sinuglar = "video";
            two = "videos";
            plural = "videos";
            isFeminine = false;
        }
    } else if (plural === "امتحان") {
        if (language === "ar") {
            sinuglar = "امتحان";
            two = "امتحانان";
            plural = "امتحانات";
            isFeminine = false;
        } else if (language === "de") {
            sinuglar = "Prüfung";
            two = "Prüfungen";
            plural = "Prüfungen";
            isFeminine = false;
        } else {
            sinuglar = "exam";
            two = "exams";
            plural = "exams";
            isFeminine = false;
        }
    } else if (plural === "محاضرة") {
        if (language === "ar") {
            sinuglar = "محاضرة";
            two = "محاضرتان";
            plural = "محاضرات";
            isFeminine = true;
        } else if (language === "de") {
            sinuglar = "Vorlesung";
            two = "Vorlesungen";
            plural = "Vorlesungen";
            isFeminine = true;
        } else {
            sinuglar = "lecture";
            two = "lectures";
            plural = "lectures";
            isFeminine = false;
        }
    } else if (plural === "مشاهدة") {
        if (language === "ar") {
            sinuglar = "مشاهدة";
            two = "مشاهدتان";
            plural = "مشاهدات";
            isFeminine = true;
        } else if (language === "de") {
            sinuglar = "Ansicht";
            two = "Ansichten";
            plural = "Ansichten";
            isFeminine = true;
        } else {
            sinuglar = "view";
            two = "views";
            plural = "views";
            isFeminine = false;
        }
    } else if (plural === "كورس") {
        if (language === "ar") {
            sinuglar = "كورس";
            two = "كورسان";
            plural = "كورسات";
            isFeminine = false;
        } else if (language === "de") {
            sinuglar = "Kurs";
            two = "Kurse";
            plural = "Kurse";
            isFeminine = false;
        } else {
            sinuglar = "course";
            two = "courses";
            plural = "courses";
            isFeminine = false;
        }
    } else if (plural === "مدرس") {
        if (language === "ar") {
            sinuglar = "مدرس";
            two = "مدرسان";
            plural = "مدرسين";
            isFeminine = false;
        } else if (language === "de") {
            sinuglar = "Lehrer";
            two = "Lehrer";
            plural = "Lehrer";
            isFeminine = false;
        } else {
            sinuglar = "teacher";
            two = "teachers";
            plural = "teachers";
            isFeminine = false;
        }
    } else if (plural === "جنيه") {
        if (language === "ar") {
            sinuglar = "جنيه";
            two = "جنيهان";
            plural = "جنيهات";
            isFeminine = false;
        } else if (language === "de") {
            sinuglar = "Pfund";
            two = "Pfund";
            plural = "Pfund";
            isFeminine = false;
        } else {
            sinuglar = "pound";
            two = "pounds";
            plural = "pounds";
            isFeminine = false;
        }
    } else if (plural === "مادة") {
        if (language === "ar") {
            sinuglar = "مادة";
            two = "مادتان";
            plural = "مواد";
            isFeminine = true;
        } else if (language === "de") {
            sinuglar = "Fach";
            two = "Fächer";
            plural = "Fächer";
            isFeminine = false;
        } else {
            sinuglar = "subject";
            two = "subjects";
            plural = "subjects";
            isFeminine = false;
        }
    } else if (plural === "طالب") {
        if (language === "ar") {
            sinuglar = "طالب";
            two = "طالبان";
            plural = "طلبة";
            isFeminine = false;
        } else if (language === "de") {
            sinuglar = "Student";
            two = "Studenten";
            plural = "Studenten";
            isFeminine = false;
        } else {
            sinuglar = "student";
            two = "students";
            plural = "students";
            isFeminine = false;
        }
    } else if (plural === "موضوع") {
        if (language === "ar") {
            sinuglar = "موضوع";
            two = "موضوعان";
            plural = "مواضيع";
            isFeminine = false;
        } else if (language === "de") {
            sinuglar = "Thema";
            two = "Themen";
            plural = "Themen";
            isFeminine = false;
        } else {
            sinuglar = "topic";
            two = "topics";
            plural = "topics";
            isFeminine = false;
        }
    } else if (plural === "تعليق") {
        if (language === "ar") {
            sinuglar = "تعليق";
            two = "تعليقان";
            plural = "تعليقات";
            isFeminine = false;
        } else if (language === "de") {
            sinuglar = "Kommentar";
            two = "Kommentare";
            plural = "Kommentare";
            isFeminine = false;
        } else {
            sinuglar = "comment";
            two = "comments";
            plural = "comments";
            isFeminine = false;
        }
    } else if (plural === "جلسة") {
        if (language === "ar") {
            sinuglar = "جلسة";
            two = "جلستان";
            plural = "جلسات";
            isFeminine = true;
        } else if (language === "de") {
            sinuglar = "Sitzung";
            two = "Sitzungen";
            plural = "Sitzungen";
            isFeminine = false;
        } else {
            sinuglar = "session";
            two = "sessions";
            plural = "sessions";
            isFeminine = false;
        }
    } else if (plural === "اشتراك غير مخصص") {
        if (language === "ar") {
            sinuglar = "اشتراك غير مخصص";
            two = "اشتراكان غير مخصصين";
            plural = "اشتراكات غير مخصصة";
            isFeminine = false;
        } else if (language === "de") {
            sinuglar = "nicht-spezifisches Abonnement";
            two = "nicht-spezifische Abonnements";
            plural = "nicht-spezifische Abonnements";
            isFeminine = false;
        } else {
            sinuglar = "non-specific subscription";
            two = "non-specific subscriptions";
            plural = "non-specific subscriptions";
            isFeminine = false;
        }
    } else if (plural === "جهاز") {
        if (language === "ar") {
            sinuglar = "جهاز";
            two = "جهازان";
            plural = "أجهزة";
            isFeminine = false;
        } else if (language === "de") {
            sinuglar = "Gerät";
            two = "Geräte";
            plural = "Geräte";
            isFeminine = false;
        } else {
            sinuglar = "device";
            two = "devices";
            plural = "devices";
            isFeminine = false;
        }
    } else if (plural === "درجة") {
        if (language === "ar") {
            sinuglar = "درجة";
            two = "درجتان";
            plural = "درجات";
            isFeminine = true;
        } else if (language === "de") {
            sinuglar = "Note";
            two = "Noten";
            plural = "Noten";
            isFeminine = false;
        } else {
            sinuglar = "grade";
            two = "grades";
            plural = "grades";
            isFeminine = false;
        }
    } else if (plural === "مادة") {
        if (language === "ar") {
            sinuglar = "مادة";
            two = "مادتان";
            plural = "مواد";
            isFeminine = true;
        } else if (language === "de") {
            sinuglar = "Fach";
            two = "Fächer";
            plural = "Fächer";
            isFeminine = false;
        } else {
            sinuglar = "subject";
            two = "subjects";
            plural = "subjects";
            isFeminine = false;
        }
    } else if (plural === "اختبار") {
        if (language === "ar") {
            sinuglar = "اختبار";
            two = "اختباران";
            plural = "اختبارات";
            isFeminine = false;
        } else if (language === "de") {
            sinuglar = "Test";
            two = "Tests";
            plural = "Tests";
            isFeminine = false;
        } else {
            sinuglar = "test";
            two = "tests";
            plural = "tests";
            isFeminine = false;
        }
    } else if (plural === "كتاب") {
        if (language === "ar") {
            sinuglar = "كتاب";
            two = "كتابان";
            plural = "كتب";
            isFeminine = false;
        } else if (language === "de") {
            sinuglar = "Buch";
            two = "Bücher";
            plural = "Bücher";
            isFeminine = false;
        } else {
            sinuglar = "book";
            two = "books";
            plural = "books";
            isFeminine = false;
        }
    } else if (plural === "صفحة") {
        if (language === "ar") {
            sinuglar = "صفحة";
            two = "صفحتان";
            plural = "صفحات";
            isFeminine = true;
        } else if (language === "de") {
            sinuglar = "Seite";
            two = "Seiten";
            plural = "Seiten";
            isFeminine = true;
        } else {
            sinuglar = "page";
            two = "pages";
            plural = "pages";
            isFeminine = false;
        }
    } else if (plural === "فصل") {
        if (language === "ar") {
            sinuglar = "فصل";
            two = "فصلان";
            plural = "فصول";
            isFeminine = false;
        } else if (language === "de") {
            sinuglar = "Kapitel";
            two = "Kapitel";
            plural = "Kapitel";
            isFeminine = false;
        } else {
            sinuglar = "chapter";
            two = "chapters";
            plural = "chapters";
            isFeminine = false;
        }
    }

    return (
        getUnit(parseInt(value), plural, sinuglar, two, isFeminine, language)["value"] +
        " " +
        getUnit(parseInt(value), plural, sinuglar, two, isFeminine, language)["label"]
    );
};
export const printRelativeDate = (date, language = "ar") => {
    moment.locale(language);
    return moment(date).fromNow();
};

export const optionsOfDays = [
    { value: "saturday", text: "السبت" },
    { value: "sunday", text: "الأحد" },
    { value: "monday", text: "الاثنين" },
    { value: "tuesday", text: "الثلاثاء" },
    { value: "wednesday", text: "الأربعاء" },
    { value: "thursday", text: "الخميس" },
    { value: "friday", text: "الجمعة" },
];
